/**
 * Wrapper de la page Surveillance existante avec le layout PWA.
 * Réutilise tout le code existant — pas de duplication.
 */
import SurveillancePage from '../../pages/Surveillance';
import { SurveillantLayout } from '../SurveillantLayout';

export default function AppelWrapper() {
  return (
    <SurveillantLayout title="Appel" fullWidth>
      <SurveillancePage />
    </SurveillantLayout>
  );
}
